import { render, staticRenderFns } from "./MstfAddMain.vue?vue&type=template&id=2f260f70&scoped=true&"
import script from "./MstfAddMain.vue?vue&type=script&lang=js&"
export * from "./MstfAddMain.vue?vue&type=script&lang=js&"
import style0 from "./MstfAddMain.vue?vue&type=style&index=0&id=2f260f70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f260f70",
  null
  
)

export default component.exports